export default __webpack_public_path__ + "static/media/file-address.2a47f59f.svg";